module.exports = __webpack_public_path__ + "ui-static/img/undraw_warning_re_eoyh 1.cdcfeaf0.svg";